/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamIdVerificationStateReviewedBy } from './oralExamIdVerificationStateReviewedBy';
import type { OralExamIdVerificationStateReviewedAt } from './oralExamIdVerificationStateReviewedAt';
import type { OralExamIdVerificationStateRejectionReasonCode } from './oralExamIdVerificationStateRejectionReasonCode';
import type { OralExamIdVerificationStateRejectionReason } from './oralExamIdVerificationStateRejectionReason';

/**
 * Per-run ID verification returned in run/cohort state responses.
 */
export interface OralExamIdVerificationState {
  status: string;
  reviewedBy?: OralExamIdVerificationStateReviewedBy;
  reviewedAt?: OralExamIdVerificationStateReviewedAt;
  rejectionReasonCode?: OralExamIdVerificationStateRejectionReasonCode;
  rejectionReason?: OralExamIdVerificationStateRejectionReason;
}
